import * as React from 'react';
export const randolphbrooksSvg = React.forwardRef(
  function randolphbrooksSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement(
        'g',
        {
          fill: 'none',
          fillRule: 'evenodd',
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#3966B3',
          d: 'M0 0h32v32H0z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          fill: '#FFF',
          d: 'M5.66 32c-.47 0 8.46-8.91 8.46-8.91L10.36 32h-4.7zM16 32c-.47 0 1.88-8.91 1.88-8.91l.94 8.91H16zm-4.7 0 5.17-9.85L15.06 32H11.3zm-1.88-7.5 2.35-7.98-6.58-4.69h7.99L16 4.33l2.82 7.5h8l-6.59 4.69 2.35 7.97L16 19.33 9.42 24.5z',
        }),
      ),
    );
  },
);
randolphbrooksSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var randolphbrooks = {
  category: 'brand',
  colorable: false,
  name: 'randolphbrooks',
  svg: randolphbrooksSvg,
};
